import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-input-password',
  templateUrl: './dialog-input-password.component.html',
  styleUrls: ['./dialog-input-password.component.scss'],
})
export class DialogInputPasswordComfirmComponent {
  password = '';
  hidePassword = true;
  constructor(
    public dialogRef: MatDialogRef<DialogInputPasswordComfirmComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data?: {
      title: string;
      detail: string;
    },
  ) {}

  agree() {
    const p = this.password.trim();
    if (!p) return;
    this.dialogRef.close(p);
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
